export default "__VITE_ASSET__BjHgxi8z__"